import { useEffect, useRef } from "react"
import { useListParams } from "./useListParams"

export function useResetParamsOnTabChange(tabId = "", keepKeys = ["tab"]) {
  const { params, resetParams } = useListParams()
  const prevTab = useRef(params?.tab)

  useEffect(() => {
    const currentTab = params?.tab

    // Run only if tab changed
    if (currentTab && currentTab !== prevTab.current) {
      prevTab.current = currentTab

      // Only reset when the tab matches the current tabId
      if (currentTab === tabId) {
        // Defer resetParams slightly to ensure new params are settled
        setTimeout(() => {
          resetParams(keepKeys, { page: 1 })
        }, 0)
      }
    }
  }, [params?.tab, tabId, resetParams])
}
